"use client";

import { c as _c } from "react/compiler-runtime";
import { TableHeader, TableHeaderCell, TextLabel } from "@opensea/ui-kit";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslations } from "use-intl";
import { CREATE_COLLECTION_OFFER_FLOW_TABLE_CLASSNAMES } from "./constants";
export const CreateCollectionOfferFlowTableHeader = () => {
  const $ = _c(36);
  const t = useTranslations("wallet.CreateCollectionOfferFlowTable");
  const {
    control
  } = useFormContext();
  let t0;
  if ($[0] !== control) {
    t0 = {
      control,
      name: "offers"
    };
    $[0] = control;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const offers = useWatch(t0);
  const firstOffer = offers[0];
  let t1;
  if ($[2] !== t) {
    t1 = t("collection");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <TableHeaderCell className={CREATE_COLLECTION_OFFER_FLOW_TABLE_CLASSNAMES.collection}><TextLabel size="2xs">{t1}</TextLabel></TableHeaderCell>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t) {
    t3 = t("floor");
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <TableHeaderCell className={CREATE_COLLECTION_OFFER_FLOW_TABLE_CLASSNAMES.floor}><TextLabel size="2xs">{t3}</TextLabel></TableHeaderCell>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== firstOffer || $[11] !== t) {
    t5 = (firstOffer?.trait || firstOffer?.traits && firstOffer.traits.length > 0) && <TableHeaderCell className={CREATE_COLLECTION_OFFER_FLOW_TABLE_CLASSNAMES.traitFloor}><TextLabel size="2xs">{t("traitFloor")}</TextLabel></TableHeaderCell>;
    $[10] = firstOffer;
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t) {
    t6 = t("topOffer");
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t6) {
    t7 = <TableHeaderCell className={CREATE_COLLECTION_OFFER_FLOW_TABLE_CLASSNAMES.bestOffer}><TextLabel size="2xs">{t6}</TextLabel></TableHeaderCell>;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== firstOffer || $[18] !== t) {
    t8 = (firstOffer?.trait || firstOffer?.traits && firstOffer.traits.length > 0) && <TableHeaderCell className={CREATE_COLLECTION_OFFER_FLOW_TABLE_CLASSNAMES.traitBestOffer}><TextLabel size="2xs">{t("topTraitOffer")}</TextLabel></TableHeaderCell>;
    $[17] = firstOffer;
    $[18] = t;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t) {
    t9 = t("offerTotal");
    $[20] = t;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t9) {
    t10 = <TableHeaderCell className={CREATE_COLLECTION_OFFER_FLOW_TABLE_CLASSNAMES.proceeds}><TextLabel size="2xs">{t9}</TextLabel></TableHeaderCell>;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t) {
    t11 = t("offeredAt");
    $[24] = t;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11) {
    t12 = <TableHeaderCell className={CREATE_COLLECTION_OFFER_FLOW_TABLE_CLASSNAMES.price}><TextLabel size="2xs">{t11}</TextLabel></TableHeaderCell>;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t10 || $[29] !== t12 || $[30] !== t2 || $[31] !== t4 || $[32] !== t5 || $[33] !== t7 || $[34] !== t8) {
    t13 = <TableHeader className="h-7 overflow-visible bg-transparent">{t2}{t4}{t5}{t7}{t8}{t10}{t12}</TableHeader>;
    $[28] = t10;
    $[29] = t12;
    $[30] = t2;
    $[31] = t4;
    $[32] = t5;
    $[33] = t7;
    $[34] = t8;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  return t13;
};
export const CreateCollectionOfferFlowTableHeaderSkeleton = () => {
  const $ = _c(26);
  const t = useTranslations("wallet.CreateCollectionOfferFlowTable");
  let t0;
  if ($[0] !== t) {
    t0 = t("collection");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <TableHeaderCell className={CREATE_COLLECTION_OFFER_FLOW_TABLE_CLASSNAMES.collection}><TextLabel size="2xs">{t0}</TextLabel></TableHeaderCell>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("floor");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <TableHeaderCell className={CREATE_COLLECTION_OFFER_FLOW_TABLE_CLASSNAMES.floor}><TextLabel size="2xs">{t2}</TextLabel></TableHeaderCell>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t("topCollectionOffer");
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = <TableHeaderCell className={CREATE_COLLECTION_OFFER_FLOW_TABLE_CLASSNAMES.bestOffer}><TextLabel size="2xs">{t4}</TextLabel></TableHeaderCell>;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("youReceive");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = <TableHeaderCell className={CREATE_COLLECTION_OFFER_FLOW_TABLE_CLASSNAMES.proceeds}><TextLabel size="2xs">{t6}</TextLabel></TableHeaderCell>;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t) {
    t8 = t("offerPrice");
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t8) {
    t9 = <TableHeaderCell className={CREATE_COLLECTION_OFFER_FLOW_TABLE_CLASSNAMES.price}><TextLabel size="2xs">{t8}</TextLabel></TableHeaderCell>;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t1 || $[21] !== t3 || $[22] !== t5 || $[23] !== t7 || $[24] !== t9) {
    t10 = <TableHeader className="h-7 overflow-visible bg-transparent">{t1}{t3}{t5}{t7}{t9}</TableHeader>;
    $[20] = t1;
    $[21] = t3;
    $[22] = t5;
    $[23] = t7;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
};